import workspaceQuery from '../../../graphql/queries/product/ProductsWarehouseWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/ProductsWarehouseListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/ProductsWarehouseQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/ProductsWarehouseDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/ProductsWarehouseMutation.graphql';
import fragment from '../../../graphql/fragments/product/ProductsWarehouseFragment.graphql';

const ProductsWarehouse = {
  type: 'Warehouse',
  title: 'Warehouses',
  formTitle: 'Warehouse',
  formUrl: '/Products/StockControl/Warehouse/Details/',
  workspaceUrl: '/Products/StockControl/Warehouse/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_WAREHOUSES',
};

export default ProductsWarehouse;
